import Vue from 'vue'
import Router from 'vue-router'
import { Toast } from 'mand-mobile'
import Home from '@/views/home'
import Login from '@/views/login'
import register from '@/views/register'
import registersuccess from '@/views/registersuccess'
import My from '@/views/my/my'
import transaction from '@/views/transaction'
import CsService from '@/views/csservice'
import Test from '@/views/test'
import AccountInfo from '@/views/my/accountInfo'
import asset from '@/views/my/asset'
import depositusdt from '@/views/recharge/depositusdt'
import deposithistory from '@/views/recharge/deposithistory'
import buyitokeninr from '@/views/recharge/buyitokeninr'
import buyinrdetail from '@/views/recharge/buyinrdetail'
import withdraw from '@/views/my/withdraw'
import withdrawhistory from '@/views/my/withdrawhistory'
import bank from '@/views/my/bank'
import bankadd from '@/views/my/bankadd'
import kycpartner from '@/views/my/kycpartner'
import linkkycpartner from '@/views/my/linkkycpartner'
import News from '@/views/news'
import Tutorial from '@/views/tutorial'
import editpassword from '@/views/my/editpassword'
import sell from '@/views/my/sell'
import sellhistory from '@/views/my/sellhistory'
import invite from '@/views/my/invite'
import myteam from '@/views/my/myteam'
import authupi from '@/views/my/authupi'
import invitelinkmanage from '@/views/my/invitelinkmanage'
import newdetail from '@/components/newdetail'
import itokenhistory from '@/views/my/itokenhistory'
import message from '@/views/my/message'
import pin from '@/views/my/pin'
import kycverify from '@/views/my/kycverify'
import agent from '@/views/my/agent'


Vue.use(Router)

const routes = [
  {
    path: '/Test',
    name: 'Test',
    component: Test
  },
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/home',
    name: 'home1',
    component: Home
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/rs/:invitercode',
    name: 'register',
    component: register
  },
  {
    path: '/registersuccess',
    name: 'registersuccess',
    component: registersuccess
  },
  {
    path: '/my',
    name: 'my',
    component: My
  },
  {
    path: '/invite',
    name: 'invite',
    component: invite
  },
  {
    path: '/myteam',
    name: 'myteam',
    component: myteam
  },
  {
    path: '/invitelinkmanage',
    name: 'invitelinkmanage',
    component: invitelinkmanage
  },
  {
    path: '/authupi/:ctid',
    name: 'authupi',
    component: authupi
  },
  {
    path: '/sell',
    name: 'sell',
    component: sell
  },
  {
    path: '/sellhistory',
    name: 'sellhistory',
    component: sellhistory
  },
  {
    path: '/accountinfo',
    name: 'accountinfo',
    component: AccountInfo
  },
  {
    path: '/editpassword',
    name: 'editpassword',
    component: editpassword
  },
  {
    path: '/my/assets',
    name: 'asset',
    component: asset
  },
  {
    path: '/my/itokenhistory',
    name: 'itokenhistory',
    component: itokenhistory
  },
  {
    path: '/my/itokenhistory/:purpose',
    name: 'itokenhistory_withpurpose',
    component: itokenhistory
  },
  {
    path: '/transaction',
    name: 'transaction',
    component: transaction
  },
  {
    path: '/depositusdt/:amount/:total',
    name: 'depositusdt',
    component: depositusdt
  },
  {
    path: '/buyitokeninr/:amount',
    name: 'buyitokeninr',
    component: buyitokeninr
  },
  {
    path: '/buyinrdetail/:orderid/:ctid',
    name: 'buyinrdetail',
    component: buyinrdetail
  },
  {
    path: '/deposithistory',
    name: 'deposithistory',
    component: deposithistory
  },
  {
    path: '/deposithistory/:method',
    name: 'deposithistory',
    component: deposithistory
  },
  {
    path: '/withdraw',
    name: 'withdraw',
    component: withdraw
  },
  {
    path: '/withdrawhistory',
    name: 'withdrawhistory',
    component: withdrawhistory
  },
  {
    path: '/banks',
    name: 'bank',
    component: bank
  },
  {
    path: '/bankadd',
    name: 'bankadd',
    component: bankadd
  },
  {
    path: '/editbank/:id',
    name: 'editbank',
    component: bankadd
  },
  {
    path: '/kycpartner',
    name: 'kycpartner',
    component: kycpartner
  },
  {
    path: '/linkkycpartner',
    name: 'linkkycpartner',
    component: linkkycpartner
  },
  {
    path: '/editkycpartner/:operate/:kycid',
    name: 'editkycpartner',
    component: linkkycpartner
  },
  {
    path: '/newdetail/:id',
    name: 'newdetail',
    component: newdetail
  },
  {
    path: '/newdedetailcode/:code',
    name: 'newdetailcode',
    component: newdetail
  },
  {
    path: '/customerservice',
    name: 'customerservice',
    component: CsService
  },
  {
    path: '/news',
    name: 'news',
    component: News
  },
  {
    path: '/message',
    name: 'message',
    component: message
  },
  {
    path: '/pin',
    name: 'pin',
    component: pin
  },
  {
    path: '/message/:id',
    name: 'message1',
    component: message
  },
  {
    path: '/tutorial',
    name: 'tutorial',
    component: Tutorial
  },
  {
    path: '/kycverify',
    name: 'kycverify',
    component: kycverify
  },
  {
    path: '/agent',
    name: 'agent',
    component: agent
  },
  // 404
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('@/views/NotFound')
  },
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new Router({
  // mode: 'history',
  routes: routes
})

const NOT_NEED_LOGIN_ROUTES_NAME = ["login", "register", "registersuccess", "NotFound", "editpassword"]

router.beforeEach((to, from, next) => {
	if (!localStorage.getItem('token')) {
		if (NOT_NEED_LOGIN_ROUTES_NAME.indexOf(to.name) !== -1) {
			next();
		} else {
      Toast.failed('Login expired!');
      router.push('/login');
		}
	} else {
		next();
	}
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js